import {
  SurveyButtonElement,
  SurveyHeadingTextElement,
  SurveyImageElement,
  SurveyLinkElement,
  SurveyRating5StarsElement,
  SurveySelectFacilityElement,
  SurveySingleSelectElement,
  SurveyTextElement,
  SurveyTextFieldElement,
  SurveyTextareaFieldElement,
  SurveyAiGeneratedTextFieldElement,
  SurveyGroupingElement,
  SurveyMultipleSelectElement,
  SocialMediaShareElement,
} from '@/models/survey-elements';

import { CheckboxElement } from '@/models/survey-elements/checkbox-element';

import { COMPONENT_TYPES } from '@/models/enums/component-types.enum';

export const DiscriminatorConfig = () => [
  {
    value: SurveyRating5StarsElement,
    name: COMPONENT_TYPES.RATING_5_STARS_ELEMENT,
  },
  {
    value: SurveyButtonElement,
    name: COMPONENT_TYPES.BUTTON,
  },
  {
    value: SurveyTextElement,
    name: COMPONENT_TYPES.TEXT_ELEMENT,
  },
  {
    value: SurveySelectFacilityElement,
    name: COMPONENT_TYPES.SELECT_FACILITY_ELEMENT,
  },
  {
    value: SurveyTextFieldElement,
    name: COMPONENT_TYPES.TEXT_FIELD_ELEMENT,
  },
  {
    value: SurveyTextareaFieldElement,
    name: COMPONENT_TYPES.TEXTAREA_FIELD,
  },
  {
    value: SurveyImageElement,
    name: COMPONENT_TYPES.IMAGE_ELEMENT,
  },
  {
    value: SurveyHeadingTextElement,
    name: COMPONENT_TYPES.HEADING_TEXT_ELEMENT,
  },
  {
    value: SurveyLinkElement,
    name: COMPONENT_TYPES.LINK_ELEMENT,
  },
  {
    value: SurveySingleSelectElement,
    name: COMPONENT_TYPES.SINGLE_BUTTON_SELECT_ELEMENT,
  },
  {
    value: SurveySingleSelectElement,
    name: COMPONENT_TYPES.SINGLE_SELECT_ELEMENT,
  },
  {
    value: SurveyAiGeneratedTextFieldElement,
    name: COMPONENT_TYPES.AI_GENERATED_TEXT_AREA_ELEMENT,
  },
  {
    value: SurveyGroupingElement,
    name: COMPONENT_TYPES.GROUPING_ELEMENT,
  },
  {
    value: CheckboxElement,
    name: COMPONENT_TYPES.CHECKBOX_ELEMENT,
  },
  {
    value: SurveyMultipleSelectElement,
    name: COMPONENT_TYPES.MULTIPLE_SELECT_ELEMENT,
  },
  {
    value: SocialMediaShareElement,
    name: COMPONENT_TYPES.SOCIAL_MEDIA_SHARE_ELEMENT,
  },
];
